export type ServerSideRenderingState = Readonly<{
    SecurityToken: string | undefined;
}>;

export const initialState: ServerSideRenderingState = {
    SecurityToken: undefined,
};

export default ServerSideRenderingState;